import React, { useState } from 'react';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { IconButton } from '@mui/material';

import ContextMenu from 'src/components/common/context_menu/ContextMenu';
import ContainerLoadingIndicator from 'src/components/common/loading/ContainerLoadingIndicator';
import { IInfoCardProps } from 'src/components/common/types/infocardTypes';

export const InfoCard: React.FC<IInfoCardProps> = ({
	title,
	columns,
	loadingKey,
	contextMenuItems,
}) => {
	const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(
		null,
	);
	const menuVisible = Boolean(anchorElement);

	const handleMenuClose = () => setAnchorElement(null);

	const handleMenuClick = (event: React.MouseEvent<HTMLElement>) =>
		setAnchorElement(event.currentTarget);

	return (
		<section className='relative p-6 mt-6 w-full bg-white rounded-md'>
			<ContainerLoadingIndicator loadingKey={loadingKey} />

			<div className='flex flex-wrap gap-2 justify-between items-center w-full text-xl tracking-normal leading-relaxed text-black'>
				<h2 className='text-lg font-medium'>{title}</h2>
				{contextMenuItems && contextMenuItems?.length > 0 && (
					<IconButton
						id='context-button'
						aria-controls={menuVisible ? 'context-menu' : undefined}
						aria-expanded={menuVisible ? 'true' : undefined}
						aria-haspopup='true'
						onClick={handleMenuClick}
					>
						<MoreHorizIcon className='text-gray-500 hover:text-gray-700' />
					</IconButton>
				)}
			</div>

			<div className='flex flex-wrap w-full mt-1.5 text-sm tracking-normal leading-5 text-black min-h-[52px]'>
				{columns.map((column, index) => (
					<div
						key={index}
						className='flex basis-1/2 sm:basis-1/2 md:flex-1 min-w-0 items-start px-1 py-2'
					>
						<div className='text-left'>
							<span className='text-gray-500 text-opacity-80 block'>
								{column.label}
							</span>
							<span className='text-black block break-words'>
								{column.value}
							</span>
						</div>
					</div>
				))}
			</div>

			<ContextMenu
				anchorElement={anchorElement}
				clearAnchorElement={() => setAnchorElement(null)}
				open={menuVisible}
				onClose={handleMenuClose}
				items={contextMenuItems}
			/>
		</section>
	);
};
